const NO_EXISTING_REWARD_LINK_KEY = 'NoExistingRewardLink'
const EXISTING_REWARD_LINK_KEY = 'ExistingRewardLink'

export const getNonExistingRouteNameEquivalent = ({ name }) =>
  `${NO_EXISTING_REWARD_LINK_KEY}-${name}`
export const getExistingRouteNameEquivalent = ({ name }) =>
  `${EXISTING_REWARD_LINK_KEY}-${name}`

export const adjustRouteNameBasedOnKey = (route, getKeyFunction) => {
  return getKeyFunction(route)
}
